import { createSelector } from '@reduxjs/toolkit';
import { alertSelector } from './alertSelector';

export const selectChatsLinkError = createSelector(alertSelector, ({ chatsLinkError }) => chatsLinkError);
